import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=3c387c25&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=ts"
export * from "./Quote.vue?vue&type=script&lang=ts"
import style0 from "./Quote.vue?vue&type=style&index=0&id=3c387c25&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c387c25",
  null
  
)

export default component.exports